import React, { useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../../lib/api";
import ProductCard from "../../components/site/ProductCard";

const CATEGORIES = ["All", "Sunglasses", "Optical", "Blue-light", "Sport", "Golf", "Women", "Limited Edition"];

export default function Shop() {
  const [items, setItems] = useState([]);
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "All";
  const [sort, setSort] = useState("featured");

  useEffect(() => {
    api.get("/products").then((r) => setItems(r.data || []));
  }, []);

  const filtered = useMemo(() => {
    let list = items;
    if (cat !== "All") list = list.filter((p) => p.category === cat);
    if (sort === "price-asc") list = [...list].sort((a, b) => a.price - b.price);
    if (sort === "price-desc") list = [...list].sort((a, b) => b.price - a.price);
    if (sort === "new") list = [...list].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    return list;
  }, [items, cat, sort]);

  return (
    <div data-testid="shop-page" className="bg-poche-ivory text-poche-black min-h-screen">
      <div className="container-x pt-16 pb-10">
        <p className="text-[11px] tracking-luxury uppercase text-poche-black/55">Atelier · Shop</p>
        <h1 className="font-serif text-5xl md:text-7xl mt-3">The Collection.</h1>
        <p className="mt-5 max-w-xl text-poche-black/70">Every silhouette engineered for the wider bridge and the deeper contour. Each piece numbered. Each piece signed.</p>
      </div>

      {/* Filters */}
      <div className="container-x border-t border-b border-poche-black/15 py-5 flex flex-wrap items-center justify-between gap-4 sticky top-[57px] md:top-[97px] bg-poche-ivory z-30">
        <div className="flex flex-wrap gap-x-6 gap-y-3">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => {
                const next = new URLSearchParams(params);
                if (c === "All") next.delete("cat"); else next.set("cat", c);
                setParams(next);
              }}
              className={`text-[11px] tracking-luxury uppercase pb-1 transition-colors ${
                cat === c ? "border-b border-poche-black text-poche-black" : "text-poche-black/55 hover:text-poche-black"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <span className="text-[11px] tracking-luxury uppercase text-poche-black/55">Sort</span>
          <select
            data-testid="sort-select"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="bg-transparent border border-poche-black/40 text-[11px] tracking-luxury uppercase px-3 py-2"
          >
            <option value="featured">Featured</option>
            <option value="new">Newest</option>
            <option value="price-asc">Price · Low to High</option>
            <option value="price-desc">Price · High to Low</option>
          </select>
        </div>
      </div>

      <div className="container-x py-14">
        <p className="text-[11px] tracking-luxury uppercase text-poche-black/55 mb-8" data-testid="results-count">{filtered.length} Pieces</p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-10">
          {filtered.map((p) => <ProductCard key={p.product_id} product={p} light />)}
        </div>
      </div>
    </div>
  );
}
